import { useState } from 'react';
import { Link } from 'react-router-dom';
import { authService } from '../../services';
import logo from '../../assets/images/logo.svg';
import '../LoginPage/LoginPage.css';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    if (!email) {
      setError('Please enter your email address');
      setLoading(false);
      return;
    }

    try {
      await authService.forgotPassword(email);
      setSuccess(true);
    } catch (err) {
      setError(err.message || 'Failed to send reset email. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-logo-section">
          <img src={logo} alt="Marquee Couriers" className="login-logo" />
          <h1 className="login-title">Forgot Password</h1>
          <p className="login-subtitle">
            Enter your email and we'll send you instructions to reset your password
          </p>
        </div>

        {error && (
          <div className="login-error">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <circle cx="10" cy="10" r="9" stroke="currentColor" strokeWidth="2"/>
              <path d="M10 6V10M10 14H10.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
            <span>{error}</span>
          </div>
        )}

        {!success ? (
          <form className="login-form" onSubmit={handleSubmit}>
            <div className="login-field">
              <label htmlFor="email">Email Address</label>
              <div className="login-input-wrapper">
                <svg className="login-input-icon" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <rect x="2" y="4" width="16" height="12" rx="2" stroke="currentColor" strokeWidth="1.5"/>
                  <path d="M2 6L10 11L18 6" stroke="currentColor" strokeWidth="1.5"/>
                </svg>
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="admin@example.com"
                  autoComplete="email"
                  disabled={loading}
                />
              </div>
            </div>

            <button type="submit" className="login-submit-btn" disabled={loading}>
              {loading ? (
                <>
                  <span className="login-spinner"></span>
                  Sending...
                </>
              ) : (
                'Send Reset Link'
              )}
            </button>

            <div className="login-footer" style={{ borderTop: 'none', marginTop: '16px', paddingTop: '0' }}>
              <Link to="/login" className="login-forgot-link">
                Back to Sign In
              </Link>
            </div>
          </form>
        ) : (
          <div style={{ textAlign: 'center' }}>
            <div style={{
              width: '64px', height: '64px', margin: '0 auto 16px',
              borderRadius: '50%', background: '#d1fae5',
              display: 'flex', alignItems: 'center', justifyContent: 'center'
            }}>
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#059669" strokeWidth="2">
                <polyline points="20 6 9 17 4 12" />
              </svg>
            </div>
            <h2 style={{ fontSize: '18px', color: '#059669', marginBottom: '8px' }}>Check Your Email</h2>
            <p style={{ fontSize: '14px', color: '#6b7280', marginBottom: '24px' }}>
              We've sent reset instructions to <strong>{email}</strong>.
            </p>
            <Link to="/login" className="login-submit-btn" style={{ textDecoration: 'none', display: 'inline-block' }}>
              Back to Sign In
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
